import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["open"]
const _hoisted_3 = { class: "metric-controls" }

import { computed } from 'vue'
import D3Plot, { Axis, Curve, Legend } from './D3Plot.vue'
import PlotControls, { PlotControlProps } from './PlotControls.vue'

export interface MetricProps {
  title: string
  description: string
  open?: boolean
  axes: { x: Axis; y: Axis }
  legend?: Legend
  globals: Record<string, PlotControlProps>
  controls: Record<string, PlotControlProps>
  compute: (param: Record<string, number>) => Curve[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MetricPanel',
  props: {
    title: {},
    description: {},
    open: { type: Boolean },
    axes: {},
    legend: {},
    globals: {},
    controls: {},
    compute: { type: Function }
  },
  setup(__props: any) {

const props = __props

// Compute curves data based on global and metric-specific control values
const curves = computed(() => {
  const allControls = { ...props.globals, ...props.controls }
  const controlValues = Object.fromEntries(
    Object.entries(allControls).map(([key, control]) => [key, control.value])
  )
  return props.compute(controlValues)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("details", {
      open: __props.open ?? false
    }, [
      _createElementVNode("summary", null, [
        _createElementVNode("b", null, _toDisplayString(__props.title), 1)
      ]),
      _createElementVNode("p", null, _toDisplayString(__props.description), 1),
      _createVNode(D3Plot, {
        axes: __props.axes,
        legend: __props.legend,
        curves: curves.value
      }, null, 8, ["axes", "legend", "curves"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(PlotControls, { controls: __props.controls }, null, 8, ["controls"])
      ])
    ], 8, _hoisted_2)
  ]))
}
}

})